import { render, staticRenderFns } from "./ContributionsReportPage.vue?vue&type=template&id=745dde5d&"
import script from "./ContributionsReportPage.vue?vue&type=script&lang=ts&"
export * from "./ContributionsReportPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports